import React, { ReactElement } from 'react';

import { useContent } from '@interstellar/react-app-content';

import { ThreeStepsToRegisterIdVerifyContent } from './ThreeStepsToRegisterIdVerifyContent';
import ThreeStepsToRegister from '../../components/threeStepsToRegister/ThreeStepsToRegister';

function ThreeStepsToRegisterIdVerify(): ReactElement {
  const { threeStepsToRegisterIdVerifyContent } =
    useContent<ThreeStepsToRegisterIdVerifyContent>();

  return (
    <ThreeStepsToRegister
      data={threeStepsToRegisterIdVerifyContent}
      externalLink
    />
  );
}

export default ThreeStepsToRegisterIdVerify;
